import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  document.querySelectorAll(".collage").forEach((root) => {
    gsap.context(() => {
      const intro = root.querySelector(".collage__intro");
      const brand = root.querySelector(".collage__brand");
      const introWrappers = root.querySelectorAll(
        ".collage__intro-image-wrapper",
      );
      const copy = root.querySelector(".collage__copy");
      const gridWrappers = root.querySelectorAll(
        ".collage__images .collage__image-wrapper",
      );

      if (intro && copy && introWrappers.length >= 2) {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: intro,
            start: "top 85%",
            toggleActions: "play none none none",
          },
          defaults: { duration: 1, ease: "power2.out", force3D: true },
        });

        if (brand) {
          tl.from(brand, { autoAlpha: 0, y: -40 }, 0);
        }

        tl.from(
          introWrappers[0],
          { autoAlpha: 0, x: -56 },
          brand ? 0.05 : 0,
        ).from(copy, { autoAlpha: 0, y: 40 }, brand ? 0.12 : 0.1);

        tl.from(introWrappers[1], { autoAlpha: 0, x: 56 }, brand ? 0.12 : 0.1);
      }

      if (gridWrappers.length) {
        gsap.from(gridWrappers, {
          autoAlpha: 0,
          y: 48,
          duration: 1,
          stagger: 0.12,
          ease: "power2.out",
          force3D: true,
          scrollTrigger: {
            trigger: root.querySelector(".collage__images"),
            start: "top 88%",
            toggleActions: "play none none none",
          },
        });
      }
    }, root);
  });
}
